import { getAppConfig } from '@bts-web/core-app-config';
import { FC } from 'react';
import { TwoFaSectionTitle } from '../../../shared/TwoFaSectionTitle';
import { TwoFaSectionButtonsWrapper } from '../../../shared/TwoFaSectionButtonsWrapper';
import { ButtonBase } from '../../../../../ButtonBase/ButtonBase';
import { css } from '@bts-web/utils-style-engine';
import { HyperLinkButtonBase } from '../../../../../HyperLinkButtonBase/HyperLinkButtonBase';
import { TwoFaScreenTranslations } from '../../utils/get2faTranslations';

const ResetTwoFaSelectResetMethod: FC<{
  onSelectAuthenticator: () => void;
  onSelectRecovery: () => void;
  dismissLoading?: boolean;
  translations: TwoFaScreenTranslations;
}> = ({
  onSelectAuthenticator,
  onSelectRecovery,
  dismissLoading,
  translations,
}) => {
  const { URLforCustomerSupport } = getAppConfig();

  return (
    <>
      <TwoFaSectionTitle title={translations.reset2faSelectMethodTitle} />
      <TwoFaSectionButtonsWrapper>
        <ButtonBase
          isLoading={dismissLoading}
          disabled={dismissLoading}
          onClick={onSelectAuthenticator}
          visual="primary"
          fullWidth
        >
          {translations.reset2faOptionAuthenticator}
        </ButtonBase>
        <ButtonBase
          isLoading={dismissLoading}
          disabled={dismissLoading}
          visual="secondary"
          fullWidth
          onClick={onSelectRecovery}
        >
          {translations.reset2faOptionRecoveryCode}
        </ButtonBase>
        {URLforCustomerSupport && (
          <HyperLinkButtonBase
            visual="ghost"
            to={URLforCustomerSupport}
            className={css({
              textDecoration: 'underline',
            })}
          >
            {translations.reset2faOptionHelpdesk}
          </HyperLinkButtonBase>
        )}
      </TwoFaSectionButtonsWrapper>
    </>
  );
};

export { ResetTwoFaSelectResetMethod };
